<div class="container">
    <div class="thanks">
        <!-- Title -->
        <div class="title-section">
            <img src="/assets/img/thanks.png" alt="THANK YOU!!">
        </div>

        <!-- Message -->
        <div class="message-section">
            <div class="message-content">
                <p style="white-space:pre-wrap">{{ "thank.content" | translate }}</p>
            </div>
        </div>

        <!-- Info box -->
        <div class="info-box">
            <!-- Barcode section -->
            <div class="barcode-section">
                <div class="barcode-label">{{ "thank.shippingNumber" | translate }}</div>
                <div class="barcode-image">
                    <svg id="barcode"></svg>
                </div>
            </div>

            <!-- Destination info -->
            <div class="info-row">
                <div class="info-content">
                    <div class="label">
                        <span>{{ "thank.shippingDestination" | translate }}</span>
                        <span>:</span>
                    </div>
                    <div class="value">
                        <p>[{{ "thank.pickupLocation" | translate }}]</p>
                        <p>{{ "thank.pickupStationName" | translate }}</p>
                        <p>[{{ 'thank.deliveryAddress' | translate }}]</p>
                        <p>{{ data?.stayFacilityName }}</p>
                    </div>
                </div>
            </div>

            <!-- Reservation name -->
            <div class="info-row">
                <div class="info-content">
                    <div class="label">
                        <span>{{ "thank.hotelReservationName" | translate }}</span>
                        <span>:</span>
                    </div>
                    <span class="value">{{data?.reserverName}}</span>
                </div>
            </div>

            <!-- Date -->
            <div class="info-row">
                <div class="info-content">
                    <div class="label">
                        <span>{{ "thank.dateOfUse" | translate }}</span>
                        <span>:</span>
                    </div>
                    <span class="value">{{data?.usageDate}}</span>
                </div>
            </div>

            <!-- Baggage -->
            <div class="info-row">
                <div class="info-content">
                    <div class="label">
                        <span>{{ "thank.baggage" | translate }} &nbsp;</span>
                        <span>:</span>
                    </div>
                    <div class="value">
                        <p *ngFor="let item of data?.shipDetail">{{item.shippingFeeName}}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Top button -->
        <button (click)="goToTop()" pButton class="btn-custom">
            TOPへ戻る
        </button>
    </div>
</div>
